import { createPinia } from 'pinia';

export const store = createPinia();

export * from './family.js';

export * from './profile.js';

export * from './settings.js';
